import $ from 'jquery';
import 'bootstrap';
import initializeNavigation from "./navigation";
import initializeNavigationMobile from "./navigation-mobile";
import onResizeWindow from "./resize"
import onWindowLoad from "./load";
import campaignsSwiper from "./campaigns_swiper";
import magazinSwiper from "./magazin_swiper";
import module_side_navigation from "./module_side_navigation";
import tariffSwiper from "./_tariff";
import faq from "./_faq";
import tariffDetails from "./_tariff_details";
import tariffModal from "./_modal_tariff";
import avuMessagesModal from "./_avu_messages_modal";
import telEmail from "./_tel_and_email";
import magazinListPostForCategory from "./magazin-post-list";
import contactFormLoadAjax from "./contact_form";
import contactFormBase from "./forms";
import avuCalculator from "./tarifrechner";
import contactSwiper from "./contact_swiper";
import presseLoadAjax from "./presse_post_list";
import advantagesSwiper from "./cards-grid-module";
import orderForm from "./order_form";
import customAccordion from "./customAccordion";
import flipBox from "./flip-box";
import avuBlockCounter from "./avu-counter";
import imageSwiper from "./image-swiper";
import avuTracking from "./tracking";
import avuNavFooter from "./navigation-footer";
import employeeCustomBlock from "./employee-block";
import gridImageText from "./grid-image-text";
import magazinGallery from "./magazin-gallery";
import tellja from "./tellja"

$(document).ready(() => {
    initializeNavigationMobile();
    initializeNavigation();
    onResizeWindow();
    onWindowLoad();
    campaignsSwiper();
    magazinSwiper();
    module_side_navigation();
    tariffSwiper();
    faq();
    tariffDetails();
    tariffModal();
    avuMessagesModal();
    telEmail();
    magazinListPostForCategory();
    contactFormLoadAjax();
    avuCalculator();
    contactFormBase();
    contactSwiper();
    presseLoadAjax();
    advantagesSwiper();
    orderForm();
    customAccordion();
    flipBox();
    avuBlockCounter('.main-counter-module');
    imageSwiper();
    avuTracking();
    avuNavFooter();
    employeeCustomBlock();
    gridImageText();
    magazinGallery();
    tellja();
});

window.onload = function() {
    let loader = document.getElementById("form-loading-spinner");
    if(loader) {
        loader.style.display = "none";
    }

};
//scroll if url has hash
$(document).ready(function() {
    function scrollToHash(hash) {
        let target = $(hash);
        let offset = 0;
        if(window.innerWidth > 992) {
            offset = 189;
        } else {
            offset = 60;
        }
        if (target.length) {
            let targetPosition = target.offset().top - offset;
            window.scroll({
                top: targetPosition,
                behavior: "smooth",
            });
        }
    }
    function handleHashChange() {
        if (window.location.hash && window.location.hash !== '#') {
            scrollToHash(window.location.hash);
        }
    }

    $(window).on('hashchange', function(event) {
        if (window.location.hash === '#') {
            event.preventDefault();
            history.replaceState(null, null, ' ');
        } else {
            handleHashChange();
        }
    });
    if (window.location.hash !== '#') {
        handleHashChange();
    }
});


$('#tariffBooking1').appendTo("body");



